/* eslint-disable max-classes-per-file */

export interface RequestNewsRoomDetailsInterface {
  newsroomSlug: string;
}
export class ResponseNewsRoomDetails {
  newsroomId: number;

  slug: string;

  subjectType: string;

  subjectTypeName: string;

  subject: string;

  publisher: string;

  publisherImage: string;

  publishDate: string;

  ordering: number;

  isPublish: number;

  meta: {
    title: string;
    description: string;
  };

  cover: {
    image1x1: string;
    image4x3: string;
    image16x9: string;
  };

  contents: {
    title: string;
    description: string;
    image: string[];
  }[];

  constructor(data: any) {
    this.newsroomId = data.newsroomId || 0;
    this.slug = data.slug || "";
    this.subjectType = data.subjectType || "";
    this.subjectTypeName = data.subjectTypeName || "";
    this.subject = data.subject || "";
    this.publisher = data.publisher || "";
    this.publisherImage = data.publisherImage || "";
    this.publishDate = data.publishDate || "";
    this.ordering = data.ordering || 0;
    this.isPublish = data.isPublish || 0;
    this.meta = {
      title: data.meta?.title || "",
      description: data.meta?.description || "",
    };
    this.cover = {
      image1x1: data.cover?.image1x1 || "",
      image4x3: data.cover?.image4x3 || "",
      image16x9: data.cover?.image16x9 || "",
    };
    this.contents =
      data.contents?.map((content: any) => ({
        title: content.title || "",
        description: content.description || "",
        image: content.image || [],
      })) || [];
  }
}
